import { useEffect, useCallback } from 'react';
import { useSelector } from '../shared/hooks';

export function useGameSelector(gameId, games, history, pathTo) {
  const gameSelector = useSelector(games, gameId);
  const { onChange } = gameSelector;
  useEffect(() => {
    onChange(gameId);
  }, [gameId, onChange]);

  const visitGame = useCallback(
    gameId => {
      history.push(pathTo('game-explorer', gameId));
    },
    [history, pathTo],
  );

  gameSelector.onChange = visitGame;

  return gameSelector;
}
